// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse .collapse-content {\n  display: block;\n  transition: all 300ms ease-in-out;\n  overflow: hidden;\n  opacity: 1;\n}\n.collapse .collapse-content.inactive {\n  opacity: 0;\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
